import React, { useState } from 'react';

import monthlyChallenge from '../../../images/v1/rewards/monthlyChallenge.svg'
import Lottie from 'react-lottie';
import animationData from '../../../animations/anim_rew_available.json'
import { redeemStreaks } from '../../../ApiCalls/Rewards/api_v1_rewards';
import RewardPopup from '../RewardPopup';
import { useTranslation } from 'react-i18next';

const MonthlyChallenge = ({ canRedeem, monthlyStreak, coins, onStreakClaimed }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const [showRewardPopup, setShowRewardPopup] = useState(false);
  const { t } = useTranslation();
  const handleRedeem = async () => {
    try {
      const res = await redeemStreaks();
      if (res && res.status === 200) {
        setShowRewardPopup(true);
      }
    } catch (e) {
    }
  };

  return (
    <>
      <div
        className="monthly-challenge"
        style={
          (canRedeem === 1 && monthlyStreak > 0)
            ? { cursor: 'pointer' }
            : {}
        }
        onClick={
          (canRedeem === 1 && monthlyStreak > 0)
            ? handleRedeem
            : undefined
        }
      >
        {(canRedeem === 1 && monthlyStreak > 0) && (
          <>
            <div className="shimmer"></div>
            <div className="sparkle-wrapper">
              <div className="sparkle"></div>
              <div className="sparkle delay-1"></div>
              <div className="sparkle delay-2"></div>
            </div>
            <div className="new-badge">{t('available')}</div>
          </>
        )}
        <div className="blur left-blur"></div>
        <div className="blur bottom-blur-monthly"></div>
        <div className="blur right-blur-monthly"></div>
        <div className="content">
          <div className="text">
            <h2 className='stroke-color-black'>{t('monthly_streak_reward')}</h2>
            <p className='stroke-color-black'>{t('monthly_rew_msg')} </p>
          </div>
          <div className="image">
            <img src={monthlyChallenge} alt="Reward box" />
          </div>
        </div>
        <style jsx>{`
          .monthly-challenge {
            background-color: #FFB985;
            border-radius: 20px;
            padding: 20px;
            position: relative;
            overflow: hidden;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease;
          }

          .monthly-challenge:hover {
            transform: translateY(-4px);
          }

          .blur {
            position: absolute;
            filter: blur(30px);
            opacity: 0.3;
          }

          .left-blur {
            background-color: #5FF5EF;
            width: 100px;
            height: 100%;
            top: 0;
            left: -50px;
          }

          .bottom-blur-monthly {
            background-color: #F48000;
            width: 100%;
            height: 60px;
            bottom: -30px;
            left: 0;
          }

          .right-blur-monthly {
            background-color: #EA5E22;
            width: 60px;
            height: 100%;
            top: 0;
            right: -30px;
          }

          .image {
            margin-left: 20px;
          }

          .image img {
            width: 80px;
            height: 80px;
            object-fit: contain;
          }

          .shimmer {
            position: absolute;
            top: 0;
            left: 0;
            width: 50%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255, 255, 255, 0.2),
              transparent
            );
            animation: shimmer 4s ease-in-out infinite;
            z-index: 2;
          }

          .sparkle-wrapper {
            position: absolute;
            inset: 0;
            overflow: hidden;
            z-index: 1;
            pointer-events: none;
          }

          .sparkle {
            position: absolute;
            background: radial-gradient(circle, white 0%, transparent 60%);
            border-radius: 50%;
            width: 20px;
            height: 20px;
            opacity: 0;
            pointer-events: none;
            animation: sparkle 3s ease-out infinite;
          }

          .delay-1 { animation-delay: 1.5s; }
          .delay-2 { animation-delay: 0.7s; }

          @keyframes shimmer {
            0% {
              transform: translateX(-150%) skewX(-20deg);
              opacity: 0;
            }
            25% {
              opacity: 1;
            }
            75% {
              opacity: 1;
            }
            100% {
              transform: translateX(150%) skewX(-20deg);
              opacity: 0;
            }
          }

          @keyframes sparkle {
            0% {
              transform: translate(20%, 20%) scale(0);
              opacity: 0;
            }
            15% {
              opacity: 0.8;
              transform: translate(60%, -30%) scale(1);
            }
            35% {
              opacity: 1;
              transform: translate(120%, -60%) scale(1.2);
            }
            45% {
              opacity: 0.8;
              transform: translate(180%, -90%) scale(1);
            }
            60% {
              opacity: 0;
              transform: translate(250%, -120%) scale(0);
            }
            100% {
              transform: translate(250%, -120%) scale(0);
              opacity: 0;
            }
          }

          .monthly-challenge:hover .sparkle {
            animation: sparkle 2s infinite;
          }

          .new-badge {
            position: absolute;
            top: 12px;
            right: 12px;
            background: linear-gradient(135deg, #FF4B4B, #FF7676);
            color: white;
            padding: 4px 8px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: bold;
            letter-spacing: 0.5px;
            z-index: 2;
            box-shadow: 0 2px 8px rgba(255, 75, 75, 0.3);
            animation: pulse 2s infinite;
          }

          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}</style>
      </div>
      {showRewardPopup && (
        <RewardPopup reward={coins} onClose={() => {
          setShowRewardPopup(false);
          onStreakClaimed && onStreakClaimed();
        }} />
      )}
    </>
  );
};

export default MonthlyChallenge;